import { searchFilterDefaults } from '@/models/insertionsParameters';
import { ConversionSource } from '@/services/tracking/GtmTrackingService';
import type { LocationQuery, RouteLocationRaw } from 'vue-router';

/**
 * Builds the redirect target for the /boost deeplink. If `propertyReferenceId` is present as a single string,
 * it pre-fills the Manage Ads searchFilter and opens the Toplisting modal for that listing.
 */
export function getBoostToplistingRedirect(query: LocationQuery): RouteLocationRaw {
  const propertyReferenceId =
    typeof query.propertyReferenceId === 'string' ? query.propertyReferenceId : undefined;

  return {
    name: 'business-listings-manage',
    query: {
      ...(propertyReferenceId
        ? {
            openToplistingModalFor: propertyReferenceId,
            searchFilter: JSON.stringify({
              ...searchFilterDefaults,
              searchQuery: [propertyReferenceId],
            }),
          }
        : {}),
      conversionSource: ConversionSource.DEEPLINK,
    },
  };
}
